// src\app\not-found.tsx
'use client';

import dynamic from 'next/dynamic';
import './globals.css';

// Import your fonts directly in this file
import { Cambay } from 'next/font/google';
import localFont from 'next/font/local';

const cambay = Cambay({
  weight: ['400', '700'],
  subsets: ['latin'],
  variable: '--font-cambay',
  display: 'swap',
});

const telegrafico = localFont({
  src: '../../public/fonts/telegrafico.woff2',
  variable: '--font-telegrafico',
  display: 'swap',
});

const helveticaNeue = localFont({
  src: [
    {
      path: '../../public/fonts/HelveticaNeueLight.woff2',
      weight: '300',
      style: 'normal',
    },
    {
      path: '../../public/fonts/HelveticaNeueRoman.woff2',
      weight: '400',
      style: 'normal',
    },
    {
      path: '../../public/fonts/HelveticaNeueMedium.woff2',
      weight: '500',
      style: 'normal',
    },
    {
      path: '../../public/fonts/HelveticaNeueBold.woff2',
      weight: '700',
      style: 'normal',
    },
  ],
  variable: '--font-helvetica-neue',
  display: 'swap',
});

// Dynamically import the Motion404RootContent to avoid including motion in main bundle
const Motion404RootContent = dynamic(() => import('./components/Motion404RootContent'), {
  ssr: false,
  loading: () => (
    <div className="min-h-svh bg-custom-bg flex items-center justify-center">
      <div className="text-communist-red text-2xl font-telegrafico">Loading...</div>
    </div>
  ),
});

export default function NotFound() {
  return (
    <html
      lang="en"
      className={`${cambay.variable} ${telegrafico.variable} ${helveticaNeue.variable}`}
    >
      <body className="bg-custom-bg font-helvetica">
        <div id="__next">
          <Motion404RootContent />
        </div>
      </body>
    </html>
  );
}
